import { useTranslations } from 'next-intl';
import styles from './loading.module.css';

export default function Loading() {
	const t = useTranslations('Generic');

	return <div className={styles.Loading}>
		<div className={styles.center}>
			{/* eslint-disable-next-line @next/next/no-img-element */}
			<img src="/icons/spinning-dots.svg" alt="icon loading" />
			<div>{t('loading')}...</div>
		</div>
	</div>
}
